<template>
  <div>
    <h1 class="m-label" style="margin: 0">生徒一覧</h1>
    <div class="m-box__inner2">

      <transition name="loading" mode="out-in">
        <template v-if="tutor.student_tutors">

          <ul class="m-List">
            <li class="m-Item" v-for="(list, index) in mapStudent_tutors" :key="index.id">

              <div class="state">
                <template v-if="new Date(Date.parse(list.guidance_period_end)) > new Date()">現在</template>
                <template v-else>過去</template>
              </div>

              <template v-if="edit_id.edit_id !== list.id">
                <template v-if="list.student">

                  <div class="m-Item__block" v-bind:class="{ unknown: list.student.gender === 0, boy: list.student.gender === 1, girl: list.student.gender === 2 }">
                    <div class="m-Item__content" v-bind:class="{ gray: new Date(Date.parse(list.guidance_period_end)) < new Date() }">
                      <i class="fa fa-user-circle"></i>
                      <div>{{list.student.f_name}} {{list.student.l_name}}({{list.student.f_name_kana}} {{list.student.l_name_kana}})</div>
                      <!-- <div>{{list.student.grade}} {{list.student.age}} 歳</div> -->
                      <!-- <div>{{list.mapGuidance_period_start}} ~ {{list.mapGuidance_period_end}}</div> -->
                      <div>{{list.guidance_period_start}} ~ {{list.guidance_period_end}}</div>
                      <div>{{list.note}}</div>
                    </div>
                    <div class="m-Item__content2">
                      <btn class="jump" @click.native="linkStudent(list)"><i class="fa fa-address-card"></i></btn>
                      <btn class="jump" @click.native="edit(list)">編集</btn>
                      <btn class="delete" @click.native="deleteTutorStudent(list)"><i class="fa fa-trash"></i></btn>
                    </div>
                  </div>

                </template>
              </template>
              <template v-if="edit_id.edit_id === list.id">
                <template v-if="list.student">

                  <div class="m-Item__block" v-bind:class="{ unknown: list.student.gender === 0, boy: list.student.gender === 1, girl: list.student.gender === 2 }">
                    <div class="m-Item__content" v-bind:class="{ gray: new Date(Date.parse(list.guidance_period_end)) < new Date() }">
                      <i class="fa fa-user-circle"></i>
                      <div>{{list.student.f_name}} {{list.student.l_name}}({{list.student.f_name_kana}} {{list.student.l_name_kana}})</div>
                      <!-- <div>{{list.student.grade}} {{list.student.age}} 歳</div> -->
                      <div>
                        <!-- <input type="text" v&#45;model="list.mapGuidance_period_start"> -->
                        <input type="text" v-model="list.guidance_period_start">
                        <!-- <input type="text" v&#45;model="list.mapGuidance_period_end"> -->
                        <input type="text" v-model="list.guidance_period_end">
                      </div>
                      <div>{{list.note}}</div>
                    </div>
                    <div class="m-Item__content2">
                      <btn class="jump" @click.native="linkStudent(list)"><i class="fa fa-address-card"></i></btn>
                      <btn class="jump" @click.native="patchStudent_tutor(list)">更新</btn>
                      <btn class="jump" @click.native="cancel(list)">戻る</btn>
                      <btn class="delete" @click.native="deleteTutorStudent(list)"><i class="fa fa-trash"></i></btn>
                    </div>
                  </div>

                </template>
              </template>

            </li>
          </ul>

        </template>
        <template v-else>
          <loading></loading>
        </template>
      </transition>

    </div>
    <router-link to="/student_tutors"><btn style="border-left: solid 1px #ccc; border-right: solid 1px #ccc">探しデータ</btn></router-link>
  </div>
</template>

<script>
let _ = window._
export default {
  name: 'TutorStudentsIndex',
  props: {
    tutor: Object
  },
  data () {
    return {
      edit_id: {
        edit_id: ''
      }
        // filing_date: '',
        // matching_type: '',
        // change_reason: '',
        // matching_month: '',
        // matching_date: '',
        // student_id: '',
        // tutor_id: '',
        // note: '',
        // guidance_period_start: '',
        // guidance_period_end: '',
    }
  },
  computed: {
    // order By
    orderedStudent_tutors () {
      return _.orderBy(this.tutor.student_tutors, 'guidance_period_end', 'desc')
    },

    mapStudent_tutors () {
      let self = this
      return self.orderedStudent_tutors.map((student_tutor) => {
        if (!student_tutor) {
          return
        }
        // student_tutor.mapGuidance_period_start = self.calcDateTime(student_tutor.guidance_period_start)
        student_tutor.guidance_period_start = self.calcGuidance_period_start(student_tutor.guidance_period_start)
        // student_tutor.mapGuidance_period_end = self.calcDateTime(student_tutor.guidance_period_end)
        student_tutor.guidance_period_end = self.calcGuidance_period_end(student_tutor.guidance_period_end)
        return student_tutor
      })
    }
  },
  watch: {
  },
  methods: {
    calcDateTime (val) {
      const datetime = new Date(val)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      let hours = datetime.getHours()
      hours = hours.toString()
      hours = hours.padStart(2, '0')
      let minutes = datetime.getMinutes()
      minutes = minutes.toString()
      minutes = minutes.padStart(2, '0')
      return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
    },

    calcGuidance_period_start (guidance_period_start) {
      if (!guidance_period_start) {
        return
      }
      let date = guidance_period_start.substring(0, 10)
      let time = guidance_period_start.substring(11, 16)
      let datetime = date + ' ' + time
      return datetime
    },

    calcGuidance_period_end (guidance_period_end) {
      if (!guidance_period_end) {
        return
      }
      let date = guidance_period_end.substring(0, 10)
      // let time = guidance_period_end.substring(11, 16)
      let datetime = date
      return datetime
    },

    calcAge (birthday) {
      if (!birthday) {
        return
      }
      var x = Date.parse(birthday) // 変換(ミリ秒が返される)
      var date = new Date(x) // ミリ秒をnew Dateに渡す
      var ageDifMs = Date.now() - date
      var ageDate = new Date(ageDifMs)
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade (birthday, grade_flag) {
      if (!birthday) {
        return
      }
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }

      let ageNumber
      if (birthdate >= new Date(year - 4, 3, 2) && birthdate <= new Date(year - 3, 3, 1, 23, 59)) {
        ageNumber = 4
      } else if (birthdate >= new Date(year - 5, 3, 2) && birthdate <= new Date(year - 4, 3, 1, 23, 59)) {
        ageNumber = 5
      } else if (birthdate >= new Date(year - 6, 3, 2) && birthdate <= new Date(year - 5, 3, 1, 23, 59)) {
        ageNumber = 6
      } else if (birthdate >= new Date(year - 7, 3, 2) && birthdate <= new Date(year - 6, 3, 1, 23, 59)) {
        ageNumber = 7
      } else if (birthdate >= new Date(year - 8, 3, 2) && birthdate <= new Date(year - 7, 3, 1, 23, 59)) {
        ageNumber = 8
      } else if (birthdate >= new Date(year - 9, 3, 2) && birthdate <= new Date(year - 8, 3, 1, 23, 59)) {
        ageNumber = 9
      } else if (birthdate >= new Date(year - 10, 3, 2) && birthdate <= new Date(year - 9, 3, 1, 23, 59)) {
        ageNumber = 10
      } else if (birthdate >= new Date(year - 11, 3, 2) && birthdate <= new Date(year - 10, 3, 1, 23, 59)) {
        ageNumber = 11
      } else if (birthdate >= new Date(year - 12, 3, 2) && birthdate <= new Date(year - 11, 3, 1, 23, 59)) {
        ageNumber = 12
      } else if (birthdate >= new Date(year - 13, 3, 2) && birthdate <= new Date(year - 12, 3, 1, 23, 59)) {
        ageNumber = 13
      } else if (birthdate >= new Date(year - 14, 3, 2) && birthdate <= new Date(year - 13, 3, 1, 23, 59)) {
        ageNumber = 14
      } else if (birthdate >= new Date(year - 15, 3, 2) && birthdate <= new Date(year - 14, 3, 1, 23, 59)) {
        ageNumber = 15
      } else if (birthdate >= new Date(year - 16, 3, 2) && birthdate <= new Date(year - 15, 3, 1, 23, 59)) {
        ageNumber = 16
      } else if (birthdate >= new Date(year - 17, 3, 2) && birthdate <= new Date(year - 16, 3, 1, 23, 59)) {
        ageNumber = 17
      } else if (birthdate >= new Date(year - 18, 3, 2) && birthdate <= new Date(year - 17, 3, 1, 23, 59)) {
        ageNumber = 18
      } else {
        ageNumber = 0
      }

      let gradeNumber = ageNumber + Number(grade_flag)

      // 月だけ0から始まるので4月は3
      let grade
      if (gradeNumber === 4) {
        grade = '幼稚園年少'
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'
      } else if (gradeNumber === 7) {
        grade = '小学1年生'
      } else if (gradeNumber === 8) {
        grade = '小学2年生'
      } else if (gradeNumber === 9) {
        grade = '小学3年生'
      } else if (gradeNumber === 10) {
        grade = '小学4年生'
      } else if (gradeNumber === 11) {
        grade = '小学5年生'
      } else if (gradeNumber === 12) {
        grade = '小学6年生'
      } else if (gradeNumber === 13) {
        grade = '中学1年生'
      } else if (gradeNumber === 14) {
        grade = '中学2年生'
      } else if (gradeNumber === 15) {
        grade = '中学3年生'
      } else if (gradeNumber === 16) {
        grade = '高校1年生'
      } else if (gradeNumber === 17) {
        grade = '高校2年生'
      } else if (gradeNumber === 18) {
        grade = '高校3年生'
      } else {
        grade = ''
      }
      return grade
    },

    edit (list) {
      this.edit_id.edit_id = list.id
    },

    cancel (list) {
      this.edit_id.edit_id = ''
    },

    linkStudent (list) {
      this.$router.push({ name: 'studentindex', params: { id: list.student_id }, exact: true })
    },

    deleteTutorStudent (list) {
      this.$store.dispatch('deleteTutorStudent', list)
    },

    patchStudent_tutor (list) {
      this.$store.dispatch('patchStudent_tutor', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.state {
  background: #f4f4f4;
  border-bottom: solid 2px #273238;
  padding: 5px;
}
.unknown {
  border-left: solid 3px #000000;
  .m-Item__content {
    .fa-user-circle {
      color: #000000;
    }
  }
}
.boy {
  border-left: solid 3px #3F51B5;
  .m-Item__content {
    .fa-user-circle {
      color: #3F51B5;
    }
  }
}
.girl {
  border-left: solid 3px #E91E63;
  .m-Item__content {
    .fa-user-circle {
      color: #E91E63;
    }
  }
}
.gray {
  background: #dddddd;
}
.m-List {
  list-style-type: none;
  margin:0;
  padding:0;
}
.m-Item {
  border: 1px solid #eee;
  position: relative;
  .fa-user-circle {
    font-size: 50px;
    margin-bottom: 5px;
  }
  &__block {
    word-wrap: break-word;
    display: flex;
    .m-Item__content {
      flex-grow: 1;
      width: 85%;
      padding: 1em;
    }
    .m-Item__content2 {
      flex-grow: 1;
      width: 30px;
      display: flex;
      flex-flow: column nowrap;
      .jump {
        /* background: #37474F; */
        margin: 0;
        flex-grow: 3;
        padding: 0;
      }
      .delete {
        background: #546E7A;
        margin: 0;
        flex-grow: 1;
        padding: 0;
      }
    }
  }
}
.m-box__inner2 {
  height: calc(100vh - 262px);
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// TutorStudentsIndex.vue?26c6f068